import React from 'react';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { CasinoLobbyScreen } from '@/feature/lobby-casino/screens/CasinoLobby';
import { PromoHubStack } from '@/feature/promohub/PromohubStack';

import { CasinoLobbyStackParamList } from './types';

const Stack = createNativeStackNavigator<CasinoLobbyStackParamList>();

export const LobbyStack = () => {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="CasinoLobbyScreen" component={CasinoLobbyScreen} />
            <Stack.Screen name="LobbyPromohub" component={PromoHubStack} />
        </Stack.Navigator>
    );
};
